<template>
    <div>
        <el-date-picker
            v-model="startDate"
            :value-format="valueFormat[0]||'yyyy-MM-dd 00:00:00'"
            :picker-options="startDatePickerOptions"
            :disabled="disabled"
            :type="type"
            style="width:calc(50% - 10px)"
        ></el-date-picker>
        -&nbsp;
        <el-date-picker
            v-model="endDate"
            :value-format="valueFormat[1]||'yyyy-MM-dd 23:59:59'"
            :picker-options="endDatePickerOptions"
            :disabled="disabled"
            :type="type"
            style="width:calc(50% - 10px)"
        ></el-date-picker>
    </div>
</template>

<script>
export default {
    name: "DateRangePicker",
    data() {
        return {
            startDate: '',
            endDate: '',
        }
    },
    props: {
        value: {
            type: Array,
            default: () => {
                return []
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        valueFormat: {
            type: Array,
            default: () => {
                return [
                    'yyyy-MM-dd 00:00:00',
                    'yyyy-MM-dd 23:59:59'
                ]
            }
        },
        type: {
            type: String,
            default: 'date'
        }
    },
    watch: {
        value: function (newVal) {
            if (Array.isArray(newVal)) {
                [this.startDate, this.endDate] = newVal
            }
        },
        returnValue: function (newVal) {

            if (Array.isArray(newVal)) {
                if( newVal.filter(item=>item).length === 0) {
                    newVal = []
                }
            }
            this.$emit('input', newVal)
        },
    },
    computed: {
        returnValue: {
            get() {
                return [this.startDate || '', this.endDate || ''];
            }
        },
        startDatePickerOptions: {
            get() {
                return {
                    disabledDate: (time) => {
                        return time.getTime() > new Date(this.endDate).valueOf()
                    }
                }
            },
            set(newVal) {

            }
        },
        endDatePickerOptions: {
            get() {
                return {
                    disabledDate: (time) => {
                        return time.getTime() < new Date(this.startDate).valueOf()
                    }
                }
            },
            set(newVal) {

            }
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DateRangePicker.vue